/*
  The Add button's total: the shown price times the quantity, kept on the button as data-total and drawn by
  CSS, so the scripts that set the button's label never need to know about it. The price row already follows
  the chosen size and plan; this follows that row and the quantity field.
*/
/* Each part sets up within a root: the page, and a product swapped in without a page load (assets/product-build.js). */
const setUp = (root) => {
  root.querySelectorAll('c4-product').forEach((product) => {
    const button = product.querySelector('[data-add-label]');
    const price = product.querySelector('[data-product-price]');
    const quantity = product.querySelector('input[name="quantity"]');
    /* A build (assets/product-build.js) keeps the button's total itself. */
    if (!button || !price || !quantity || product.querySelector('c4-product-build')) return;
    const sync = () => {
      const text = price.textContent.trim();
      const match = text.match(/[\d,]+(?:\.\d+)?/);
      if (!match) return button.removeAttribute('data-total');
      const total =
        parseFloat(match[0].replace(/,/g, '')) * Math.max(1, Number(quantity.value) || 1);
      button.dataset.total =
        text.slice(0, match.index) +
        total.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    new MutationObserver(sync).observe(price, {
      childList: true,
      characterData: true,
      subtree: true,
    });
    ['input', 'change', 'click'].forEach((type) =>
      product.addEventListener(type, () => requestAnimationFrame(sync)),
    );
    sync();
  });

  /*
    A long description is cut with Continue reading; short ones, and pages without the script, show in full. On
    the two-column layout the cut is not a fixed number of lines: the description takes whatever room the first
    screen has between the name and the options (CSS), and is only cut if it still does not fit. Nor is it cut to
    hide a line or two: only when more than two and a half lines would go is Continue reading worth its click.
  */
  root.querySelectorAll('[data-description]').forEach((description) => {
    const toggle = description.parentElement.querySelector('[data-description-toggle]');
    if (!toggle) return;
    let opened = false;
    const measure = () => {
      if (opened) return;
      description.dataset.clamped = '';
      toggle.hidden = true;
      const style = getComputedStyle(description);
      const line = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
      const cut = description.scrollHeight - description.clientHeight > line * 2.5;
      description.toggleAttribute('data-clamped', cut);
      toggle.hidden = !cut;
    };
    toggle.addEventListener('click', () => {
      opened = description.toggleAttribute('data-clamped') === false;
      toggle.setAttribute('aria-expanded', String(opened));
      toggle.textContent = opened ? toggle.dataset.less : toggle.dataset.more;
    });
    addEventListener('resize', measure, { passive: true });
    measure();
  });

  /*
    The quantity and Add button rest under the Price row and, once scrolling brings them to the foot of the view,
    stay there (CSS sticky). They turn to glass only while they are held there, away from the first screen, not
    while they rest on the page. (Shopify's preview bar is allowed for theme-wide, by --preview-bar.)
  */
  root.querySelectorAll('.buy-bar').forEach((bar) => {
    const lead = bar.parentElement.querySelector('.product-lead');
    if (!lead || bar.closest('.c4-product--simple')) return;
    let queued = false;
    const read = () => {
      queued = false;
      bar.toggleAttribute(
        'data-floating',
        lead.getBoundingClientRect().bottom < bar.getBoundingClientRect().top - 16,
      );
    };
    const schedule = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(read);
      }
    };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    setTimeout(schedule, 1500);
    schedule();
  });
};
setUp(document);
document.addEventListener('c4:section-load', ({ target }) => setUp(target));
